<template>
  <div style="position: relative; width: 100%; height: auto">
    <div class="main-news-wrapper">
      <div class="inner" ref="inner">
        <template v-for="(list, index) in latestNews" :key="index">
          <component
            :is="
              list.length !== pageSize
                ? 'universalList'
                : `bar${index.toString().substr(-1)}`
            "
            :list="list"
            transition-mode="out-in"
          />
        </template>
      </div>
      <div
        v-if="show.spinner"
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 44px 0;
        "
        :style="{ height: latestNews.length > 0 ? 'unset' : '80vh' }"
      >
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, reactive, watch } from "vue";
import AdditionalBar from "@/components/AdditionalBar";
import MainBar from "@/components/society/MainBar.vue";
import FirstBar from "@/components/society/FirstBar";
import SecondBar from "@/components/society/SecondBar";
import ThirdBar from "@/components/society/ThirdBar";
import FourthBar from "@/components/society/FourthBar";
import { useStore } from "vuex";
import { useInfiniteScroll } from "@/utils/infiniteScroll";
import { useLanguage } from "@/utils/language";

export default {
  components: {
    // defaultBar: MainBar,
    universalList: AdditionalBar,
    bar0: MainBar,
    bar1: FirstBar,
    bar2: SecondBar,
    bar3: ThirdBar,
    bar4: FourthBar,
    bar5: MainBar,
    bar6: FirstBar,
    bar7: SecondBar,
    bar8: ThirdBar,
    bar9: FourthBar,
  },
  setup() {
    const store = useStore();
    const inner = ref(null);
    const show = reactive({
      spinner: true,
    });

    const { i18n } = useLanguage();

    const scrollEnd = () => {
      show.spinner = false;
    };

    const pageSize = 6;

    const { startInfiniteScroll, loadData } = useInfiniteScroll({
      wrapper: inner,
      retrieve: (load, cb) => {
        store.dispatch("getLatestNews", {
          pageSize,
          cb: () => cb(),
          category: "society",
          load,
        });
      },
      newsCount: computed(() => store.getters.newsCount),
      currentPage: computed(() => store.getters.currentPage),
      pageSize,
      scrollEnd,
    });

    const refreshData = () => {
      store.commit("flushArticleState");

      show.spinner = true;
      startInfiniteScroll();
      loadData();
    };

    refreshData();

    watch(() => i18n.global.locale.value, refreshData);

    return {
      inner,
      show,
      pageSize,
      latestNews: computed(() => store.getters.latestNews),
    };
  },
};
</script>

<style lang="scss" scoped>
.main-news-wrapper {
  background: #ac95b1;
  width: 100%;
  overflow-x: hidden;
  position: relative;

  @media screen and (max-width: 1400px) {
    font-size: 14px;
  }
  .inner {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 3.125rem;
    :deep() .card {
      .main-image {
        border-radius: 0px;
      }
      img {
        border-radius: 0px;
      }
      &__title {
        font-size: 1.15em;
        color: #fff;
        line-height: 1.3;
        font-weight: 500;
        font-family: "Source Serif Pro", serif;
      }
      &__brief {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 0.88em;
        line-height: 150%;
        color: rgba(255, 255, 255, 0.8);
      }
      &__category {
        color: rgba(255, 255, 255, 0.7);
        font-size: 0.94em;
        line-height: 2;

        font-family: "Open Sans", sans-serif;
      }
      .data-news {
        color: rgba(255, 255, 255, 0.8);
        font-size: 0.88em;
        line-height: 3;
        font-family: "Open Sans", sans-serif;
      }
      @media screen and (max-width: 992px) {
        &__title {
          font-size: 1.3em;
          line-height: 1.3;
        }
        &__category {
          font-size: 1.08em;
          line-height: 2;
        }
        .data-news {
          font-size: 1em;
          line-height: 3;
        }
        &__brief {
          font-size: 0.88em;
          line-height: 150%;
        }
      }
      @media screen and (max-width: 767px) {
        &__title {
          font-size: 1.07em;
          color: #fff;
          line-height: 1.3;
        }
        &__category {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.94em;
          line-height: 2;
        }
        .data-news {
          color: rgba(255, 255, 255, 0.8);
          font-size: 0.88em;
          line-height: 3;
        }
      }
    }
  }
}
</style>
